import React from "react";
import HOC from "../../components/HOC";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import BillingManualList from "../../components/screen/billingManual/BillingManualList";
import BreadcrumbBillingManual from "../../components/screen/billingManual/BreadcrumbBillingManual";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";

const BillingManualListPage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={(isWarehouse ? "Central Warehouse " : "") + "Billing Manual"}
        mainComponent={
          <ThemeProvider theme={theme}>
            <BillingManualList
              isWarehouse={isWarehouse ? isWarehouse : false}
            />
          </ThemeProvider>
        }
        breadcrumb={
          <BreadcrumbBillingManual
            isWarehouse={isWarehouse ? isWarehouse : false}
          />
        }
        pageRole={isWarehouse ? 28 : 7}
        noPadding={true}
      />
    </div>
  );
};

export default HOC(BillingManualListPage);
